
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-265e261f&scoped=true!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./recentmember.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./recentmember.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-265e261f!../../node_modules/vue-loader/lib/selector?type=template&index=0!./recentmember.vue"),
  /* scopeId */
  "data-v-265e261f",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/dashboard/recentmember.vue
// module id = 664
// module chunks = 0